module.exports = __webpack_public_path__ + "static/media/banner-1.9757ab70.jpg";